/**
 * Format duration in milliseconds to HH:MM:SS.mmm
 */
export function formatDuration(ms) {
  if (!ms || ms < 0) return '00:00:00.00'
  
  const hours = Math.floor(ms / 3600000)
  const minutes = Math.floor((ms % 3600000) / 60000)
  const seconds = Math.floor((ms % 60000) / 1000)
  const hundredths = Math.floor((ms % 1000) / 10)
  
  const pad = (n) => n.toString().padStart(2, '0')
  return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds) + '.' + pad(hundredths)
}

/**
 * Parse time input string to timestamp
 * Supports: "HH:MM:SS.mmm", "+30", "-15", ISO timestamp
 */
export function parseTimeInput(input, baseTime) {
  if (!input) return null
  
  const trimmed = input.trim()
  
  // Relative adjustment (+30 or -15 seconds)
  if (trimmed.startsWith('+') || trimmed.startsWith('-')) {
    const seconds = parseFloat(trimmed)
    if (!isNaN(seconds) && baseTime) {
      return new Date(new Date(baseTime).getTime() + seconds * 1000).toISOString()
    }
    return null
  }
  
  // HH:MM:SS.mmm format
  if (trimmed.match(/^\d{1,2}:\d{2}:\d{2}(\.\d+)?$/)) {
    return trimmed
  }
  
  // ISO timestamp or date string
  const parsed = new Date(trimmed)
  if (!isNaN(parsed.getTime())) {
    return parsed.toISOString()
  }
  
  return null
}

/**
 * Format timestamp with timezone
 */
export function formatTimestamp(timestamp, timezone) {
  if (!timestamp) return ''
  
  try {
    const date = new Date(timestamp)
    if (isNaN(date.getTime())) return timestamp
    
    // Simple formatting without timezone lib (Vue 2 compatible)
    const pad = (n) => n.toString().padStart(2, '0')
    const year = date.getFullYear()
    const month = pad(date.getMonth() + 1)
    const day = pad(date.getDate())
    const hours = pad(date.getHours())
    const minutes = pad(date.getMinutes())
    const seconds = pad(date.getSeconds())
    
    return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
  } catch (e) {
    return timestamp
  }
}

/**
 * Get participant full name
 */
export function getFullName(participant) {
  if (!participant) return ''
  
  const name = participant.name || ''
  const secondName = participant.secondName || ''
  
  if (name && secondName) {
    return secondName + ' ' + name
  }
  
  return name || secondName || participant.userId || 'Участник'
}

/**
 * Get status display text
 */
export function getStatusText(status) {
  const statusMap = {
    finished: 'Финишировал',
    dnf: 'НФ',
    dsq: 'ДСК',
    dns: 'НС',
    running: 'В процессе',
  }
  
  return statusMap[status] || status
}

/**
 * Get status badge variant
 */
export function getStatusVariant(status) {
  const variantMap = {
    finished: 'success',
    dnf: 'warning',
    dsq: 'danger',
    dns: 'secondary',
    running: 'info',
  }
  
  return variantMap[status] || 'secondary'
}

